export function isEngagementRevenueEligible(
    eventDate?: string,
    launchDate?: string
): boolean {
    if (!launchDate) return true;

    const launchTimestamp = Date.parse(launchDate);
    if (Number.isNaN(launchTimestamp)) return true;

    const eventTimestamp = Date.parse(eventDate || "");
    return !Number.isNaN(eventTimestamp) && eventTimestamp >= launchTimestamp;
}

export function filterRevenueEligibleEngagements<T extends { eventDate?: string }>(
    engagements: T[],
    launchDate?: string
): T[] {
    return engagements.filter(engagement =>
        isEngagementRevenueEligible(engagement.eventDate, launchDate)
    );
}
